;(function() {
  'use strict'

  Controller.$inject = ["glDialog", "$timeout", "$window", "breadcrumbsService", "configService", "dashboardAggregatesResource", "acquiredPublicationsExporter", "surveyTransactionsExporter", "subscriberReportExporter", "creditTransactionsExporter", "surveyReportExporter", "channelReportExporter"];
  angular.module('app.dashboard').controller('Dashboard', Controller)

  /* ngInject */
  function Controller(
    glDialog,
    $timeout,
    $window,
    breadcrumbsService,
    configService,
    dashboardAggregatesResource,
    acquiredPublicationsExporter,
    surveyTransactionsExporter,
    subscriberReportExporter,
    creditTransactionsExporter,
    surveyReportExporter,
    channelReportExporter
  ) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.formatDateTime = formatDateTime
    ctrl.formatDateLabel = formatDateLabel
    ctrl.formatNumber = formatNumber
    ctrl.loadDashboard = loadDashboard
    ctrl.normalizeWindowDays = normalizeWindowDays
    ctrl.shortDate = shortDate
    ctrl.showAcquiredPublicationsExporter = acquiredPublicationsExporter.show
    ctrl.showSurveyTransactionsExporter = surveyTransactionsExporter.show
    ctrl.showSubscriberReportExporter = subscriberReportExporter.show
    ctrl.showCreditTransactionsExporter = creditTransactionsExporter.show
    ctrl.showSurveyReportExporter = surveyReportExporter.show
    ctrl.showChannelReportExporter = channelReportExporter.show
    ctrl.windowDays = 30
    ctrl.windowOptions = [7, 30, 90]
    var activeCharts = []

    function onInit() {
      breadcrumbsService.addBreadcrumb('Dashboard', 'home')
      loadDashboard()
    }

    function loadDashboard() {
      ctrl.loading = true
      ctrl.error = null

      dashboardAggregatesResource
        .get({ window: ctrl.windowDays })
        .success(function(resource) {
          destroyCharts()
          ctrl.dashboard = buildDashboard(resource)
          ctrl.windowDays = ctrl.dashboard.windowDays
          ctrl.loading = false
          $timeout(renderCharts)
        })
        .error(function(error) {
          destroyCharts()
          ctrl.error = error && error.message ? error.message : 'Unable to load metrics'
          glDialog.alert('', 'Error fetching dashboard metrics\n\n' + ctrl.error, {
            parent: '.main-content',
          })
          ctrl.loading = false
        })
    }

    function buildDashboard(data) {
      var completes = metricDocs(data, 'survey_completes_by_day')
      var surveys = metricDocs(data, 'surveys_created_by_day')
      var channelsStarted = metricDocs(data, 'channels_started_by_day')
      var subscribers = metricDocs(data, 'subscribers_created_by_day')
      var responseTypes = metricDocs(data, 'survey_response_types')
      var channelBilling = metricDocs(data, 'audience_channel_billing_by_type')
      var completesBySurvey = metricDocs(data, 'survey_completes_by_survey')
      var totalCompletes = sumCounts(completes)
      var topSurveyCompletes = sumCounts(completesBySurvey)

      return {
        generatedAt: data.generatedAt,
        windowDays: normalizeWindowDays(data.windowDays),
        warnings: metricWarnings(data),
        kpis: [
          { title: 'Survey completes', value: totalCompletes },
          { title: 'Surveys', value: sumCounts(surveys) },
          { title: 'Channels started', value: sumCounts(channelsStarted) },
          { title: 'Subscribers', value: sumCounts(subscribers) },
        ],
        charts: [
          dailyChart('survey-completes-chart', 'Survey completes by day', 'survey completes', completes),
          dailyChart('surveys-created-chart', 'Surveys created by day', 'surveys', surveys),
          dailyChart('channels-created-chart', 'Channels started by day', 'channels', channelsStarted),
          dailyChart('subscribers-created-chart', 'New subscribers by day', 'subscribers', subscribers),
          groupChart('survey-response-types-chart', 'Survey responses by type', 'type', responseTypes),
          groupChart(
            'audience-channel-types-chart',
            'Completes by channel type',
            'type',
            channelBilling,
            'billingCompletes'
          ),
        ],
        topSurveyCompletes: topSurveyCompletes,
        totalCompletes: totalCompletes,
        surveys: decorateSurveyRows(completesBySurvey, topSurveyCompletes),
      }
    }

    function dailyChart(id, title, emptyLabel, points) {
      return chart(id, title, emptyLabel, points, function(point) {
        return point.date
      })
    }

    function groupChart(id, title, labelKey, points, valueKey) {
      return chart(id, title, title, points, function(point) {
        return point[labelKey] || 'Unknown'
      }, valueKey)
    }

    function chart(id, title, emptyLabel, points, labelFor, valueKey) {
      var chartPoints = points.map(function(point) {
        return {
          label: labelFor(point),
          value: Number(point[valueKey || 'count'] || 0),
        }
      })
      var total = chartPoints.reduce(function(sum, point) {
        return sum + point.value
      }, 0)

      return { id: id, title: title, emptyLabel: emptyLabel, points: chartPoints, total: total }
    }

    function renderCharts() {
      if (!$window.Chart || !ctrl.dashboard) return

      destroyCharts()

      ctrl.dashboard.charts.forEach(function(chart) {
        var canvas = document.getElementById(chart.id)
        if (!canvas || !chart.points.length) return

        activeCharts.push(new $window.Chart(canvas, chartConfig(chart)))
      })
    }

    function chartConfig(chart) {
      var isDaily = chart.points.length && /^\d{4}-\d{2}-\d{2}$/.test(chart.points[0].label)

      return {
        type: 'bar',
        data: {
          labels: chart.points.map(function(point) {
            return point.label
          }),
          datasets: [
            {
              data: chart.points.map(function(point) {
                return point.value
              }),
              backgroundColor: '#009688',
              borderRadius: 0,
              barPercentage: isDaily ? 0.9 : 0.72,
              categoryPercentage: isDaily ? 0.92 : 0.72,
            },
          ],
        },
        options: {
          animation: false,
          maintainAspectRatio: false,
          responsive: true,
          scales: {
            x: {
              border: { color: '#dddddd' },
              grid: { display: false },
              ticks: {
                autoSkip: true,
                color: '#888888',
                font: { size: 10 },
                maxRotation: 0,
                callback: function(value) {
                  var label = this.getLabelForValue(Number(value))
                  return isDaily ? shortDate(label) : truncateLabel(label)
                },
              },
            },
            y: {
              beginAtZero: true,
              border: { display: false },
              grid: { color: '#eeeeee' },
              ticks: {
                color: '#888888',
                font: { size: 10 },
                precision: 0,
              },
            },
          },
          plugins: {
            legend: { display: false },
            tooltip: {
              backgroundColor: '#333333',
              displayColors: false,
              padding: 9,
              titleFont: { size: 12, weight: 'normal' },
            },
          },
        },
      }
    }

    function destroyCharts() {
      while (activeCharts.length) {
        activeCharts.pop().destroy()
      }
    }

    function decorateSurveyRows(points, total) {
      return points.slice(0, 10).map(function(point) {
        var label = point.subscriberName
          ? point.subscriberName + ' - ' + (point.title || point.surveyId || 'Unknown survey')
          : point.title || point.surveyId || 'Unknown survey'

        return {
          label: label,
          count: Number(point.count || 0),
          href: point.surveyId
            ? configService.getSubscriberPortalUrl('/surveys/' + encodeURIComponent(point.surveyId))
            : null,
          width: total > 0 ? Math.max((Number(point.count || 0) / total) * 100, 3) : 0,
        }
      })
    }

    function metricDocs(data, metricName) {
      return (data.metrics && data.metrics[metricName] && data.metrics[metricName].docs) || []
    }

    function metricWarnings(data) {
      return Object.keys(data.errors || {})
        .filter(function(metric) {
          return data.errors[metric]
        })
        .map(function(metric) {
          return { metric: metric.replace(/_/g, ' '), message: data.errors[metric] }
        })
    }

    function sumCounts(points) {
      return points.reduce(function(total, point) {
        return total + Number(point.count || 0)
      }, 0)
    }

    function formatNumber(value) {
      return new Intl.NumberFormat('en-AU').format(Number(value || 0))
    }

    function formatDateTime(value) {
      if (!value) return ''

      return new Intl.DateTimeFormat('en-AU', {
        dateStyle: 'medium',
        timeStyle: 'short',
      }).format(new Date(value))
    }

    function formatDateLabel(value) {
      return new Intl.DateTimeFormat('en-AU', {
        dateStyle: 'medium',
      }).format(new Date(value + 'T00:00:00.000Z'))
    }

    function truncateLabel(value) {
      return value.length > 14 ? value.slice(0, 13) + '...' : value
    }

    function shortDate(value) {
      if (!value) return ''

      return new Intl.DateTimeFormat('en-AU', {
        day: 'numeric',
        month: 'short',
      }).format(new Date(value + 'T00:00:00.000Z'))
    }

    function normalizeWindowDays(value) {
      return value === 7 || value === 30 || value === 90 ? value : 30
    }
  }
})()
